import { render } from "./px-corner-ribbon.vue?vue&type=template&id=64f13d60&scoped=true&ts=true"
import script from "./px-corner-ribbon.vue?vue&type=script&lang=ts"
export * from "./px-corner-ribbon.vue?vue&type=script&lang=ts"

import "./px-corner-ribbon.vue?vue&type=style&index=0&id=64f13d60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f13d60"]])

export default __exports__